import Head from 'next/head';
import { useSelector } from 'react-redux';
import { NextSeo } from 'next-seo';
import { fetchContent } from '@actions/summit';
import Summit from '@cont/Summit/Summit';
import setupInitialProps from '@utils/setupInitialProps';
import Layout from '@layout/FreeLayout/FreeLayout';
import { summitTypes } from '@actions-constants/index';
import redirect from '@cont/App/redirect';
import PageReduxProvider from '@cont/App/PageReduxProviderWrapper';
import Script from 'next/script';
import { segment } from '@actions/analytics';
import { useEffect } from 'react';
import { GTM_PAGE_VIEW } from '@events/events';

const SummitPage = () => {
  const metaData = useSelector(({ summit }) => summit.metaData);
  useEffect(() => {
    segment.track(GTM_PAGE_VIEW, {});
  }, []);
  const {
    title: metaTitle,
    description,
    ogImageURL,
    twitterImageURL
  } = metaData;

  return (
    <>
      {metaData.title ? (
        <>
          <NextSeo
            title={metaTitle}
            description={description}
            openGraph={{
              title: metaTitle,
              description,
              images: [
                {
                  url: ogImageURL
                }
              ]
            }}
            twitter={{
              images: [{ url: twitterImageURL }]
            }}
          />
          <Head>
            <title>{metaTitle}</title>
          </Head>
        </>
      ) : null}
      <Script
        async
        src="https://www.googletagmanager.com/gtag/js?id=AW-10852057838"
      />
      <Script
        strategy="worker"
        dangerouslySetInnerHTML={{
          __html:
            "window.dataLayer = window.dataLayer || [];function gtag(){dataLayer.push(arguments);}gtag('js', new Date());gtag('config', 'AW-10852057838');"
        }}
        id="gtm-script"
      />
      <Summit />
    </>
  );
};

SummitPage.pageInfo = {
  isMWebSupported: true,
  layoutOptions: {
    hideHeader: true,
    hideSearch: true,
    disableDarkMode: true,
    hideIntercom: true,
    hideFreshbot: true
  }
};

SummitPage.getInitialProps = setupInitialProps(
  async ({ store, query, isServer, req, res }) => {
    const { summitKey } = query;
    if (summitKey === 'ucl') {
      if (isServer) {
        res.writeHead(302, {
          Location: '/event/UCL?redirect=true'
        });
        return res.end();
      }
    }
    const data = await store.dispatch(fetchContent(summitKey));
    if (data.type === `${summitTypes.FETCH_CONTENT}_FAILURE`) {
      return redirect(isServer, { as: '/404', href: '/404' }, { res }, {});
    }
    return {
      isServer,
      userAgent: isServer ? req.headers['user-agent'] : ''
    };
  },
  SummitPage.pageInfo
);

export default SummitPage;
SummitPage.Layout = Layout;
SummitPage.Wrapper = PageReduxProvider;
